export default __webpack_public_path__ + "static/media/kick.1d842c55.wav";